import { render, staticRenderFns } from "./h5ConfigList.vue?vue&type=template&id=9bf53c76&scoped=true"
import script from "./h5ConfigList.vue?vue&type=script&lang=js"
export * from "./h5ConfigList.vue?vue&type=script&lang=js"
import style0 from "./h5ConfigList.vue?vue&type=style&index=0&id=9bf53c76&prod&lang=css"
import style1 from "./h5ConfigList.vue?vue&type=style&index=1&id=9bf53c76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf53c76",
  null
  
)

export default component.exports